"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var WindowImportError_1 = require("./WindowImportError");

var WindowImportWindowIdentification_1 = require("./WindowImportWindowIdentification");
/**
 * Operation result of XLS Window Import.
 * @author OPt
 * @author PKr
 */


var WindowImportResult =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowImportResult, _DomainObject_1$Domai);

  /**
   * @param id
   * @param monitorId
   * @param filename Name of the imported file.
   * @param date Datetime of the import.
   * @param result Result of the operation – true/false.
   * @param createdWindows List of created Window identifications.
   * @param errors List of validation errors.
   */
  function WindowImportResult(id, monitorId, filename, date, result, createdWindows, errors) {
    var _this;

    _classCallCheck(this, WindowImportResult);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowImportResult).call(this));
    _this.id = id;
    _this.monitorId = monitorId;
    _this.filename = filename;
    _this.date = date;
    _this.result = result;
    _this.createdWindows = createdWindows;
    _this.errors = errors;
    return _this;
  }

  return WindowImportResult;
}(DomainObject_1.DomainObject);

exports.WindowImportResult = WindowImportResult;

WindowImportResult.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowImportResult.name);
  return {
    id: builder.str('id'),
    monitorId: builder.str('monitorId'),
    filename: builder.str('filename'),
    date: builder.date('date', DateParser_1.DateParser.ISO_PATTERN),
    result: builder.bool('result'),
    createdWindows: builder.listOf(builder.obj('createdWindows', WindowImportWindowIdentification_1.WindowImportWindowIdentification.schema, function (mat) {
      return new WindowImportWindowIdentification_1.WindowImportWindowIdentification(mat.id, mat.name, mat.startDate, mat.endDate, mat.productCount, mat.warningFlags);
    })),
    errors: builder.listOf(builder.obj('errors', WindowImportError_1.WindowImportError.schema, function (mat) {
      return new WindowImportError_1.WindowImportError(mat.description, mat.line, mat.column);
    }))
  };
}();